var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCraveroLanis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 73.0892V103.934C118 111.699 111.699 118 103.934 118H74.104C65.7732 118 59 111.227 59 102.896V89.1136C59 72.4756 72.4756 59 89.1136 59H103.911C111.699 59 118 65.3012 118 73.0892Z",
    fill: "#DEB526"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.229 59H89.1136C72.4756 59 59 45.5244 59 28.8864V17.7708C59 11.21 66.9296 7.92962 71.5788 12.5788L89.68 30.68L105.421 46.4212C110.07 51.0704 106.79 59 100.229 59Z",
    fill: "#026359"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 88.5C59 88.9012 59 89.3024 58.9528 89.68C58.3628 105.421 45.3828 118 29.5 118C21.358 118 13.9712 114.696 8.6376 109.362C3.304 104.029 0 96.642 0 88.5C0 80.358 3.304 72.9712 8.6376 67.6376C12.6496 63.6256 17.818 60.77 23.6 59.59C25.5116 59.2124 27.4704 59 29.5 59C37.642 59 45.0288 62.304 50.3624 67.6376C55.696 72.9712 59 80.358 59 88.5Z",
    fill: "#B92C2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 16.7324V30.2316C59 46.1144 46.1144 59 30.2316 59H17.7236C15.694 59 13.7116 58.174 12.272 56.7344C8.6376 53.0764 5.9236 50.3624 2.2656 46.728C0.826 45.2884 0 43.306 0 41.2764V18.9272C0 16.6852 0.8968 14.5376 2.478 12.9564C6.3012 9.1568 9.1568 6.3012 12.9564 2.478C14.5376 0.8968 16.6852 0 18.9272 0H42.2676C43.778 0 45.194 0.59 46.256 1.652L57.348 12.744C58.41 13.806 59 15.222 59 16.7324Z",
    fill: "#D395A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1136 59.0001C72.4756 59.0001 59 72.4757 59 89.1137V89.6801H58.9528C59 89.3025 59 88.9013 59 88.5001C59 80.3581 55.696 72.9713 50.3624 67.6377C45.0288 62.3041 37.642 59.0001 29.5 59.0001H30.2316C46.1144 59.0001 59 46.1145 59 30.2317V28.8865C59 45.5245 72.4756 59.0001 89.1136 59.0001Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraveroLanis);
export default __webpack_public_path__ + "static/media/cravero-lanis.e5f208e30378a01fd4a4e41b90c74e48.svg";
export { ForwardRef as ReactComponent };